import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./i18n/fr.json";
import ar from "./i18n/ar.json";
import en from "./i18n/en.json";

export const RTL_LANGS = ["ar"];
export function applyDirection(lang: string) {
  document.documentElement.lang = lang;
  document.documentElement.dir = RTL_LANGS.includes(lang) ? "rtl" : "ltr";
}
const saved = (() => { try { return localStorage.getItem("ect.lang"); } catch { return null; } })();

void i18n.use(initReactI18next).init({
  resources: { fr: { translation: fr }, ar: { translation: ar }, en: { translation: en } },
  lng: saved ?? "fr",
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
});
i18n.on("languageChanged", (l) => { applyDirection(l); try { localStorage.setItem("ect.lang", l); } catch { /* private mode */ } });
applyDirection(i18n.language);
export default i18n;
